export const Greetings = props => {
    return <>
        <h1>Hello, {props.name}!</h1>
    </>
}